import store from '@/app/store/store';
import { API } from '@/app/services/api-url';

export function authIntercept(config) {
  if (store.getters['auth/loggedIn'] && !config.url.startsWith('/borg')) {
    const idToken = store.state.auth.user.signInUserSession.idToken.jwtToken;
    if (idToken) {
      config.headers.Authorization = idToken;
    }
  }
  return config;
}

export function pdfIntercept(config) {
  if (config.url === '/pdf') {
    config.headers.Accept = 'application/pdf';
    config.responseType = 'arraybuffer';
  }
  return config;
}

export function borgIntercept(config) {
  if (config.url.startsWith('/borg') && store.getters['account/getBorgApiKey']) {
    config.headers['x-api-key'] = store.getters['account/getBorgApiKey'];
    delete config.Authorization;
  }
  return config;
}

export async function postIntercept(response) {
  if (response.config.method === 'post' && response.status === 201) {
    store.dispatch('account/refreshAccounts');
  }
  return response;
}

API.registerInterceptor('REQUEST', authIntercept);
API.registerInterceptor('REQUEST', borgIntercept);
API.registerInterceptor('REQUEST', pdfIntercept);
API.registerInterceptor('RESPONSE', postIntercept);
